import React from 'react';
import { TextInputRecord } from 'types/dynamic-forms/records/TextInputRecord';
import WizardTextInputControlledComponent from 'components/v2/epd-wizard-inputs/WizardTextInputControlled';
import useProperty from '../hooks/useProperty';
import usePropertyPath from '../hooks/usePropertyPath';

const TextInputRenderer: React.FC<TextInputRecord> = ({ propertyId, tooltip, label, helpText }) => {
  const propertyPath = usePropertyPath(propertyId);
  const { value, setValue, isVisible, isDisabled, errorMessage } = useProperty<string>(propertyPath);
  if (!isVisible) {
    return null;
  }

  return (
    <WizardTextInputControlledComponent
      label={label}
      tooltip={tooltip}
      helpText={helpText}
      name={propertyId}
      value={value}
      onChange={(ev) => setValue(ev.target.value)}
      onChanged={() => {}}
      error={errorMessage}
      disabled={isDisabled}
    />
  );
};

export default TextInputRenderer;
